<p-blockUI [blocked]="loaderService.loading">
    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <p-progressSpinner></p-progressSpinner>
    </div>
</p-blockUI>
<router-outlet></router-outlet>
